/* tslint:disable */
/* eslint-disable */
/**
 * Ordering Api
 * Its4 Plan Ordering Api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectWithAmount
 */
export interface ProjectWithAmount {
    /**
     * 
     * @type {string}
     * @memberof ProjectWithAmount
     */
    projectName: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectWithAmount
     */
    amount: number;
}

/**
 * Check if a given object implements the ProjectWithAmount interface.
 */
export function instanceOfProjectWithAmount(value: object): value is ProjectWithAmount {
    if (!('projectName' in value) || value['projectName'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function ProjectWithAmountFromJSON(json: any): ProjectWithAmount {
    return ProjectWithAmountFromJSONTyped(json, false);
}

export function ProjectWithAmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectWithAmount {
    if (json == null) {
        return json;
    }
    return {
        
        'projectName': json['projectName'],
        'amount': json['amount'],
    };
}

  export function ProjectWithAmountToJSON(json: any): ProjectWithAmount {
      return ProjectWithAmountToJSONTyped(json, false);
  }

  export function ProjectWithAmountToJSONTyped(value?: ProjectWithAmount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectName': value['projectName'],
        'amount': value['amount'],
    };
}

